import React, {
  CSSProperties,
  FC, useEffect, useState,
} from 'react';
import { FaChevronLeft } from 'react-icons/fa6';
import {
  Row, Button,
} from './Styles';
import { updateFoodifoxData } from '../../../../lib/axios/FoodifoxDataAPI';
import { ChatBotIcon, Question, Home } from '../../../../assets/svg-image';
import LanguageButton from '../LanguageButton';
import FAQModal from '../FAQModal';
import { getUserId } from '../../../../lib/Authentication';
import InterRegularText from '../../../../components/Text/InterRegularText';
import PingFangMediumText from '../../../../components/Text/PingFangMediumText';
import { isMobile } from '../../../../lib/utils/utils';

const Header: FC<Props> = ({
  cabId32Str,
  isEnglish,
  setIsEnglish,
  style,
  languageStyle,
  showSupport = true,
  supportTextColor,
  showHome = false,
  showFAQ = true,
  faqTextColor,
  showBackIcon = false,
  supportIsOnlyCall = false,
  backToPage,
  backIconColor,
  languageColor,
  languageIcon,
  setTargetPage,
  operationRole,
  onClose,
}) => {
  const [addAccessFaqLog] = updateFoodifoxData('/foxH5RentLog/saveAccessFaqLog');
  const [saveCallLog] = updateFoodifoxData('/foxH5RentLog/saveCallServiceLog');
  // 显示问题帮助
  const [showFAQModal, setShowFAQModal] = useState<boolean>(false);

  /**
   * 记录访问问题帮助日志记录
   */
  useEffect(() => {
    if (showFAQModal) {
      addAccessFaqLog({
        param: {
          cabId: cabId32Str,
          roleCode: operationRole || '',
          authId: getUserId(),
        },
      });
    }
  }, [showFAQModal]);

  return (
    <>
      {
        showFAQModal && (
          <FAQModal
            setShowModal={setShowFAQModal}
            faqTarget={operationRole || 'all'}
            isEnglish={isEnglish}
          />
        )
      }
      <Row style={{ justifyContent: 'space-between', ...style }}>
        <Row>
          {
            // 返回箭头
            onClose && (
              <Button
                style={{ marginLeft: isMobile() ? 15 : undefined }}
                onClick={() => {
                  onClose();
                }}
              >
                <FaChevronLeft style={{ fontSize: '20px', marginTop: '7px', color: '#11202B' }} />
              </Button>
            )
          }
          {
            showSupport && (
              <Button
                onClick={() => {
                  if (supportIsOnlyCall) {
                    location.href = 'tel:1300359889';
                    saveCallLog({
                      param: {
                        cabId: cabId32Str,
                        telNumber: '1300359889',
                      },
                    });
                  }
                  else if (setTargetPage) {
                    setTargetPage('support');
                  }
                }}
                style={{ marginLeft: onClose ? (isMobile() ? 5 : undefined) : (isMobile() ? 20 : undefined), color: '#11202B', width: '45px' }}
              >
                <img src={ChatBotIcon} style={{ width: '27px', height: '27px' }} />
                {
                  isEnglish ? (
                    <InterRegularText fontSize={11} opacity={0.5} marginTop={5}>
                      Support
                    </InterRegularText>
                  ) : (
                    <PingFangMediumText fontSize={11} color={'#000000'} opacity={0.5} marginTop={5}>
                      帮助
                    </PingFangMediumText>
                  )
                }
              </Button>
            )
          }
          {
            showHome && (
              <Button
                onClick={() => setTargetPage != null && setTargetPage('home')}
                style={{ marginLeft: onClose ? 5 : 20, color: '#11202B', width: '45px', marginTop: '-2px' }}
              >
                <img src={Home} style={{ width: '32px', height: '32px' }} />
                {
                  isEnglish ? (
                    <InterRegularText fontSize={11} opacity={0.5} marginTop={3}>
                      Home
                    </InterRegularText>
                  ) : (
                    <PingFangMediumText fontSize={11} color={'#000000'} opacity={0.5} marginTop={3}>
                      首页
                    </PingFangMediumText>
                  )
                }
              </Button>
            )
          }
          {
            showFAQ && (
              <Button
                onClick={() => {
                  setShowFAQModal(true);
                }}
                style={{ marginLeft: '5px', color: '#11202B', width: '45px' }}
              >
                <img src={Question} style={{ width: '25px', height: '25px' }} />
                {
                  isEnglish ? (
                    <InterRegularText fontSize={11} opacity={0.5} marginTop={7}>
                      FAQ
                    </InterRegularText>
                  ) : (
                    <PingFangMediumText fontSize={11} color={'#000000'} opacity={0.5} marginTop={7}>
                      常见问题
                    </PingFangMediumText>
                  )
                }
              </Button>
            )
          }
          {
            /* 返回箭头 */
            showBackIcon && (
              <Button
                style={{ marginLeft: '15px', marginTop: '-15px' }}
                onClick={() => {
                  if (backToPage && setTargetPage) {
                    setTargetPage(backToPage);
                  }
                }}
              >
                <FaChevronLeft style={{ fontSize: '20px', marginTop: '7px', color: backIconColor || '#11202B' }} />
              </Button>
            )
          }
        </Row>
        <LanguageButton
          isEnglish={isEnglish}
          setIsEnglish={setIsEnglish}
          languageColor={languageColor}
          languageIcon={languageIcon}
          style={languageStyle}
        />
      </Row>
    </>
  );
};

export interface Props {
  cabId32Str?: string;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  showSupport?: boolean;
  supportTextColor?: string;
  showHome?: boolean;
  showFAQ?: boolean;
  faqTextColor?: string;
  showBackIcon?: boolean;
  backToPage?: string;
  backIconColor?: string;
  languageColor?: string;
  languageIcon?: any;
  style?: CSSProperties;
  languageStyle?: CSSProperties;
  setTargetPage?: (targetPage: string) => void;
  supportIsOnlyCall?: boolean;
  operationRole?: string;
  onClose?: () => void;
}

export default Header;
